import { render, staticRenderFns } from "./HowToInvestMain.vue?vue&type=template&id=db55d67e&scoped=true"
import script from "./HowToInvestMain.vue?vue&type=script&lang=js"
export * from "./HowToInvestMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db55d67e",
  null
  
)

export default component.exports